export class Notificationpreference {
    organizationId:string;
    personId:string;
    preference:string;
    lastupdate:Date;
    preferencevalue:boolean;
}